import { Archive, CheckCircle, Inbox01, XCircle } from '@untitledui/icons';
import type { FC } from 'react';

import type { AiActionsView } from '@/lib/localStorage/aiActionsSortPrefs';
import type { ProposalListItem } from '@/lib/proposals/core/types';

import type { PriorityTier } from '../utils/groupProposalsByTier';

/** A bulk operation whose scope was resolved at request time: either a whole
    priority group (tier = the group's tier) or the cross-group selection from
    the SelectionToolbar (tier = 'selected'). Carrying the resolved action
    list keeps the confirmation dialog and the execute path in lockstep — no
    re-deriving scope from selectedIds later. */
export interface PendingBulk {
  tier: PriorityTier | 'selected';
  actions: ProposalListItem[];
  buttonLabel: string;
}

export const VIEW_TABS: {
  id: AiActionsView;
  label: string;
  icon: FC<{ className?: string }>;
}[] = [
  { id: 'open', label: 'Open', icon: Inbox01 },
  { id: 'done', label: 'Done', icon: CheckCircle },
  { id: 'dismissed', label: 'Dismissed', icon: XCircle },
  // TODO(copy): 'Archived' is a banned state word — naming decision, needs Laura sign-off
  { id: 'archived', label: 'Archived', icon: Archive },
];

export const RESOLUTION_FOR_VIEW: Record<
  Exclude<AiActionsView, 'open'>,
  'approved' | 'rejected' | 'withdrawn'
> = {
  done: 'approved',
  dismissed: 'rejected',
  archived: 'withdrawn',
};
